import TagFilters from 'Components/Table/TableComponents/TagFilters'
import { useAppSelector } from 'hooks'

function TagContainer(props) {
  const tableColumns = useAppSelector(state => state.present.subRule.filterColumns)
  const emptyTableColumns = useAppSelector(state => state.present.subRule.emptyFilterColumns)
  const emptyExtraDescriptions = []
  const negateTableColumns = useAppSelector(state => state.present.subRule.negateColumns)
  const tableFilters = useAppSelector(state => state.present.subRule.tableFilters)
  const priceFilter = {}

  const defaultCols = useAppSelector(state => state.present.subRule.defaultColumns)
  const allMarketplace = useAppSelector(state => state.present.configuration.allMarketplace)

  return (
    <TagFilters
      tableColumns={tableColumns}
      emptyTableColumns={emptyTableColumns}
      emptyExtraDescriptions={emptyExtraDescriptions}
      negateTableColumns={negateTableColumns}
      tableFilters={tableFilters}
      priceFilter={priceFilter}
      defaultCols={defaultCols}
      allMarketplace={allMarketplace}
    />
  )
}

export default TagContainer
